// components/TabComponent.js
"use client";

import React, { useState } from "react";

export default function TabComponent({ tabs }) {
  const [activeTab, setActiveTab] = useState(tabs[0].name);

  return (
    <>
      <div className="tab-titles">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            className={activeTab === tab.name ? "active" : ""}
            onClick={() => setActiveTab(tab.name)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {tabs.map((tab) => (
        <div
          key={tab.name}
          className={
            activeTab === tab.name ? "tab-content active" : "tab-content"
          }
        >
          {tab.content}
        </div>
      ))}
    </>
  );
}
